import { E_RISK_TYPE, VIEW } from 'interfaces';
import React from 'react';
import { IMobxRootState } from '../../RootStore';
import ChartContainer from 'components/GQChart/ChartContainer';
import { inject } from 'mobx-react';
import useInitCountryDim from 'hooks/useInitCountryDim';
import useInitChart from 'hooks/useInitChart';
import { CrossCountryRiskPage } from 'components/Pickers/CrossCountryRiskPicker';

type Props = {
    height?: number;
};

export const WorldGraphPage = React.memo(() => {
    return (
        <CrossCountryRiskPage>
            <WorldGraph />
        </CrossCountryRiskPage>
    );
});

export const WorldGraph = inject(({ chartStore }: IMobxRootState) => {
    return {
        height: chartStore.height,
    };
})(({ height }: Props) => {
    useInitChart();
    const ready = useInitCountryDim({
        riskType: E_RISK_TYPE.DIMENSIONS,
        multiCountry: true,
        multiRisk: false,
    });
    return (
        ready && (
            <ChartContainer
                height={height}
                activeView={VIEW.WORLD_GRAPH}
                changeDataWhenDragStop={true}
            />
        )
    );
});
